<template>
	<select @change="changed" v-model="selectedMode">
		<option value="solve">Actual Solve Time</option>
		<option value="adjusted">Adjusted Solve Time</option>
		<option value="checks">Check/Reveal Counts</option>
	</select>
</template>
<script>
import store from '../state';

export default {
	name: 'CalendarViewToggle',
	data: function() {
		return {
			selectedMode: (localStorage && localStorage.calendarDisplayMode) || "solve",
		}
	},
	methods: {
		changed: function(val) {
			store.commit('setCalendarDisplayMode', this.selectedMode);
			try {
				localStorage.calendarDisplayMode = this.selectedMode;
			} catch(e) {}
		},
	},
}
</script>
<style scoped lang="scss">
select {
	background-color: #e0e0e0;
	border-width: 0;
	display: inline-block;
	width: auto;
	padding: 1px 5px;
	height: auto;
	border-radius: 8px;
	cursor: pointer;
	text-align: center;
	text-align-last: center;

	// hide the arrow from the select box
	appearance: none;
	-moz-appearance: none;
	-webkit-appearance: none;
	&::-ms-expand {
		display: none;
	}
}
</style>
